import React from 'react'

import { ValidateProcessSettingsMutation } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { handleResult } from 'modules/core/lib/handleMutation'

import { useValidateProcessSettings } from 'modules/processes/hooks/process/useValidateProcessSettings'
import type { Process } from 'modules/processes/hooks/useProcesses'

export type ProcessValidationData =
  ValidateProcessSettingsMutation['processesMutations']['validateSettingsProcessesProcess']['process']

const useProcessSettiingsValidation = (process?: Process | null) => {
  const [loading, setloading] = React.useState<boolean>(false)
  const [processValidationData, setProcessValidationData] =
    React.useState<ProcessValidationData | null>(null)
  const { validateProcessSettings } = useValidateProcessSettings()

  const validate = async () => {
    setloading(true)
    const handled = handleResult(await validateProcessSettings({ id: process!.id }), (errors) => {
      setloading(false)
      if (errors) throw 'Process validation error: ' + JSON.stringify(errors)
    })
    setProcessValidationData(handled.success ? handled.data.process : null)
    setloading(false)
  }

  useEffect(() => {
    if (process?.id) validate()
  }, [process?.id]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    loading,
    processValidationData,
  }
}

export default useProcessSettiingsValidation
